import { EyeSlashIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const HideEye = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <EyeSlashIcon {...rest} size={Sizes[size]} color={fill} />;
};

HideEye.displayName = 'HideEye';
